import i18n from '@aqx/i18n';

import { EChartIndicator } from '@aqx-core/common/api/user-account-setting';

export const chartMainIndicators = [
  EChartIndicator.TI_BOLL,
  EChartIndicator.TI_EMA,
  EChartIndicator.TI_MA,
  EChartIndicator.TI_SAR,
  EChartIndicator.TI_WMA
];

export const chartSubIndicators = [
  EChartIndicator.TI_ATR,
  EChartIndicator.TI_CCI,
  EChartIndicator.TI_MACD,
  EChartIndicator.TI_RSI,
  EChartIndicator.TI_SD,
  EChartIndicator.TI_SO
];

export const chartMainIndicatorNative = [
  EChartIndicator.TI_MA,
  EChartIndicator.TI_SAR,
  EChartIndicator.TI_BOLL,
  EChartIndicator.TI_EMA,
  EChartIndicator.TI_WMA
];

export const chartSubIndicatorNative = [
  EChartIndicator.TI_MACD,
  EChartIndicator.TI_CCI,
  EChartIndicator.TI_RSI,
  EChartIndicator.TI_SD,
  EChartIndicator.TI_SO,
  EChartIndicator.TI_ATR
];

export const chartMainAndSubIndicators = [...chartMainIndicators, ...chartSubIndicators];

export const mapChartIndicatorTitle: Record<EChartIndicator, string> = {
  [EChartIndicator.TI_MA]: 'MA',
  [EChartIndicator.TI_SAR]: 'SAR',
  [EChartIndicator.TI_BOLL]: 'BOLL',
  [EChartIndicator.TI_EMA]: 'EMA',
  [EChartIndicator.TI_WMA]: 'WMA',
  [EChartIndicator.TI_MACD]: 'MACD',
  [EChartIndicator.TI_CCI]: 'CCI',
  [EChartIndicator.TI_RSI]: 'RSI',
  [EChartIndicator.TI_SD]: 'SD',
  [EChartIndicator.TI_SO]: 'SO',
  [EChartIndicator.TI_ATR]: 'ATR',
  [EChartIndicator.TI_WEMA]: 'WEMA',
  [EChartIndicator.TI_FIBONACCI]: 'FIBONACCI',
  [EChartIndicator.TI_ICHIMOKU]: 'ICHIMOKU',
  [EChartIndicator.TI_ADX]: 'ADX',
  [EChartIndicator.TI_HEIKINASHI]: 'HEIKINASHI',
  [EChartIndicator.TI_STOCHASTIC]: 'STOCHASTIC',
  [EChartIndicator.TI_WILLIAMSR]: 'WILLIAMSR'
};

export const mapIndicatorFullName: Record<EChartIndicator, () => string> = {
  [EChartIndicator.TI_BOLL]: () => i18n.t('Bollinger Bandwidth'),
  [EChartIndicator.TI_EMA]: () => i18n.t('Moving Average Exponential'),
  [EChartIndicator.TI_MA]: () => i18n.t('Moving Average'),
  [EChartIndicator.TI_SAR]: () => i18n.t('Parabolic SAR'),
  [EChartIndicator.TI_WMA]: () => i18n.t('Weighted Moving Average'),

  [EChartIndicator.TI_ATR]: () => i18n.t('Average True Range'),
  [EChartIndicator.TI_CCI]: () => i18n.t('Commodity Channel Index'),
  [EChartIndicator.TI_MACD]: () => i18n.t('Moving Average Convergence Divergence'),
  [EChartIndicator.TI_RSI]: () => i18n.t('Relative Strength Index'),
  [EChartIndicator.TI_SD]: () => i18n.t('Standard Deviation'),
  [EChartIndicator.TI_SO]: () => i18n.t('Stochastic Oscillator'),

  [EChartIndicator.TI_WEMA]: () => i18n.t('Weighted Exponential Moving Average'),
  [EChartIndicator.TI_FIBONACCI]: () => i18n.t('Fibonacci Retracement'),
  [EChartIndicator.TI_ICHIMOKU]: () => i18n.t('Ichimoku Cloud'),
  [EChartIndicator.TI_ADX]: () => i18n.t('Average Directional Index'),
  [EChartIndicator.TI_HEIKINASHI]: () => i18n.t('Heikin-Ashi'),
  [EChartIndicator.TI_STOCHASTIC]: () => i18n.t('Stochastic'),
  [EChartIndicator.TI_WILLIAMSR]: () => i18n.t('Williams %R')
};
